import axios from "axios";
import { API_URL } from "../config/config";
import { getHeaderOptions } from "./header";

const API_ENDPOINT = API_URL + '/api';

export function placesByCategory(data, params) {
    return axios.put(`${API_ENDPOINT}/place/placesbycategory`, data, { headers: getHeaderOptions(), params: params })
}

export function placeDetail(id, params) {
    return axios.get(`${API_ENDPOINT}/place/placedetail?mkmID=${id}`, { headers: getHeaderOptions(), params: params })
}

export function tzadikimCategory(data, params) {
    return axios.put(`${API_ENDPOINT}/place/tzadikimlist`, data, { headers: getHeaderOptions(), params: params })
}

export function tzadikimDetail(params) {
    return axios.get(`${API_ENDPOINT}/place/TzadikimDetail`, { headers: getHeaderOptions(), params: params })
}

export function report_suggestion(data) {
    return axios.post(`${API_ENDPOINT}/place/ReportSuggestion`, data, { headers: getHeaderOptions() })
}

// export function categoryDetailAbout(params) {
//     return axios.get(`${WIKIPEDIA_API_URL}`, { headers: getHeaderOptions(), params: params })
// }